import { z } from "zod";

export const timesheetApprovalSchema = z
  .object({
    date: z.string(), // Add this line
    approved_hours: z.coerce
      .number()
      .min(0, "Approved hours cannot be negative"),
    unapproved_hours: z.coerce
      .number()
      .min(0, "Unapproved hours cannot be negative"),
    reason: z.string().nullable().optional(),
  })
  .refine(
    (data) => {
      return data.approved_hours + data.unapproved_hours <= 24;
    },
    {
      message: "Total approved and unapproved hours cannot exceed 24 hours",
      path: ["approved_hours"],
    }
  );
